export default {
  "b2b.fixniNaroky.nasledujiciWidgetTitle": "Fixed claims",
  "b2b.fixniNaroky.nasledujiciWidgetTitleDescription": "FOR THE FOLLOWING WEEK",
  "b2b.fixniNaroky.nasledujiciItemSmlouva": "Contract",
  "b2b.fixniNaroky.nasledujiciCountTitleVzo": "LTR",
  "b2b.fixniNaroky.nasledujiciCountTitleMzo": "STR"
};
